/* eslint-disable @typescript-eslint/no-explicit-any */
import Dropdown, { IDropdownItem, IDropdownProps } from "@/core/components/dropdown";
import { WarningCircle } from "@phosphor-icons/react";

interface IFormItemProps {
  name: string,
  label?: string,
  options: IDropdownItem[],
  placeholder?: string,
  errors?: any,
  disabled?: boolean,
  onChange?: (value: any) => void,
  closeEnable?: boolean
}

const Select = ({ name, label, placeholder, options, errors, disabled, onChange, closeEnable, ...dropdownProps }: IFormItemProps & Omit<IDropdownProps, "dataSource" | "onChange">) => {
  return (
    <div className={`dv-form__select ${errors?.[name]?.message ? 'dv-form__select--error' : ''}`}>
      <label>{label}</label>
      <Dropdown 
        dataSource={options} 
        placeholder={placeholder} 
        disabled={disabled} 
        onChange={onChange}
        closeEnable={closeEnable}
        {...dropdownProps} 
      />
      {
        errors?.[name]?.message &&
        <div className="danger-text">
          <WarningCircle size={16} />{errors?.[name]?.message}
        </div>
      }
    </div>
  )
}

export default Select;